import React from 'react';
import {connect} from 'react-redux';
import {TextField as PolarisTextField} from '@shopify/polaris';
import Input from './input';

class TextField extends Input {
  _render() {
    const {input} = this.props;
    const {error} = input;

    return (
      <PolarisTextField
        id={input.handle}
        type={input.type}
        min={input.minValue}
        step={input.step}
        label={input.label}
        helpText={renderHelpText(input.helpText)}
        placeholder={input.placeholder}
        value={input.value}
        prefix={input.prefix}
        suffix={input.suffix}
        onChange={this.handleChange}
        error={error}
      />
    );
  }
}

function renderHelpText(helpText) {
  return helpText ? (
    <span dangerouslySetInnerHTML={{__html: helpText}} />
  ) : null;
}

export default connect(
  TextField.mapStateToProps,
  TextField.mapDispatchToProps
)(TextField);
